// src/js/actions/index.js
import { ADMIN_LOGIN} from "../constants/action-types";
export const adminLogin = adminInfo => ({ type: ADMIN_LOGIN, payload: adminInfo });
